export default __webpack_public_path__ + "c00f238c9e24985963455deb4e4acb84.png";